import React from 'react'
import { Text } from 'rebass'
import {
  Paragraph,
  MainHeader,
  SubHeader,
  SectionHeader,
} from '../atoms/RulesTypography'

const FortniteRules = () => {
  return (
    <>
      <MainHeader />
      <SubHeader text="Fornite" />
      <SectionHeader text="rulebooks" />
      <Paragraph>
        CSL Fortnite 2020-2021 Tournament Rulebook: <a href="https://drive.google.com/file/d/1k4YU-Muf1JqT1CbteDQtVesK78MJjmM7/view?usp=sharing" target="_blank" rel="noopener noreferrer">
            CSL-Fortnite-2020-2021-Rules.pdf
          </a><br />
          Lone Star College Fortnite Intramurals Rulebook (Fall 2020): <a href="https://drive.google.com/file/d/12gEg4mgDn6lSV5KfW61b08Kf_HbIPJ3v/view?usp=sharing" target="_blank" rel="noopener noreferrer">
            Lone-Star-College-Intramurals-Fortnite-Rules.pdf
          </a>
      </Paragraph>
      <Text mb={'1rem'}>
        <h3>
          FOR ANY Fortnite RELATED QUESTIONS - PLEASE FEEL FREE TO EMAIL US AT{'  '}
          <a href="mailto:support@cslesports.gg" target="_top">
            SUPPORT@CSLESPORTS.GG{' '}
          </a>
          OR SPEAK TO AN ADMIN on{' '}
          <a href="https://discord.gg/cslesportsgg" target="_blank" rel="noopener noreferrer">
            DISCORD
          </a>{' '}
          in the #fortnite-help chat.
        </h3>
      </Text>
    </>
  )
}

export default FortniteRules
